/* eslint-disable */
<template>

<div>
  <nav class="fixed z-10 w-full bg-live-blue">
    <div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
      <div class="flex items-center justify-between h-16">
        <div class="flex items-center">
          <div class="flex-shrink-0">
            <router-link :to="{ name: 'Home' }">
                <img class="w-1/3 mx-auto" src="@/assets/logo.svg" alt="Live@Home Logo" />
            </router-link>
          </div>
          <div class="hidden md:block">
            <ul class="flex items-baseline ml-10">
              <li>
                <router-link :to="{ name: 'Dashboard' }" class="px-3 py-2 mx-2 text-sm font-medium text-white rounded-md hover:bg-blue-600 focus:outline-none focus:text-white">Dashboard</router-link>
              </li>
              <li>
                <router-link :to="{ name: 'Streams' }" class="px-3 py-2 mx-2 text-sm font-medium text-white rounded-md hover:bg-blue-600 focus:outline-none focus:text-white">Streams</router-link>
              </li>
            </ul>
          </div>
        </div>
        <Menu />
        <div class="flex -mr-2 md:hidden">
          <button 
            class="inline-flex items-center justify-center p-2 text-gray-400 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:bg-gray-700 focus:text-white"
            @click="toggleVisibility"
            @keydown.space.exact.prevent="toggleVisibility"
            @keydown.esc.exact="hideDropdown"
            @keydown.shift.tab="hideDropdown"
            @keydown.up.exact.prevent="startArrowKeys"
            @keydown.down.exact.prevent="startArrowKeys"
          >
            <svg class="w-6 h-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
              <path :class="{'hidden': isVisible, 'inline-flex': !isVisible }" class="inline-flex" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
              <path :class="{'hidden': !isVisible, 'inline-flex': isVisible }" class="" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
    <div :class="{'block': isVisible, 'hidden': !isVisible}" class="md:hidden">
      <ul class="px-2 pt-2 pb-3 sm:px-3">
        <li href="#" class="block px-3 py-2 text-base font-medium text-white bg-gray-900 rounded-md focus:outline-none focus:text-white focus:bg-gray-700">Dashboard</li>
        <li href="#" class="block px-3 py-2 mt-1 text-base font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700">Event</li>
      </ul>
      <div class="pt-4 pb-3 border-t border-gray-700">
        <div class="flex items-center px-5">
          <div class="flex-shrink-0">
            <img class="w-10 h-10 rounded-full" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="" />
          </div>
          <div class="ml-3">
            <div class="text-base font-medium leading-none text-white">Tom Cook</div>
            <div class="mt-1 text-sm font-medium leading-none text-gray-400">tom@example.com</div>
          </div>
        </div>
        <div class="px-2 mt-3">
          <router-link :to="{ name: 'Home' }" class="block px-3 py-2 text-base font-medium text-gray-400 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700">{{ $t('user.profile') }}</router-link>
          <router-link :to="{ name: 'Home' }" class="block px-3 py-2 mt-1 text-base font-medium text-gray-400 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700">{{ $t('user.settings') }}</router-link>
        </div>
      </div>
    </div>
  </nav>
</div>

</template>

<script>
import { mixin as clickaway } from "vue-clickaway";
import * as firebase from "firebase/app";
import "firebase/auth";

import Menu from "@/components/Menu";

export default {
  components: {
    Menu
  },
  mixins: [ clickaway ],
  data() {
    return {
      isVisible: false,
      focusedIndex: 0,
    }
  },
  methods: {
    toggleVisibility() {
      this.isVisible = !this.isVisible
    },
    hideDropdown() {
      this.isVisible = false
      this.focusedIndex = 0
    },
    startArrowKeys() {
      if (this.isVisible) {
        // this.$refs.account.focus()
        this.$refs.dropdown.children[0].children[0].focus()
      }
    },
    focusPrevious(isArrowKey) {
      this.focusedIndex = this.focusedIndex - 1
      if (isArrowKey) {
        this.focusItem()
      }
    },
    focusNext(isArrowKey) {
      this.focusedIndex = this.focusedIndex + 1
      if (isArrowKey) {
        this.focusItem()
      }
    },
    focusItem() {
      this.$refs.dropdown.children[this.focusedIndex].children[0].focus()
    },
    async signOut(){
        try {
            await firebase.auth().signOut();
            this.isVisible = false
            this.focusedIndex = 0
            this.$router.replace({ name: 'Home' });
        } catch (error) {
            console.log(error);
        }
    }

  }
}
</script>

<style lang="scss" scoped>

 nav li .router-link-active,
 nav li .router-link-exact-active {
   background-color: #ff6d2d;
   cursor: pointer;
 }
</style>